import React from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Paper,
  Button,
  Divider,
  Chip,
} from '@mui/material';
import {
  FaInstagram,
  FaTelegramPlane,
  FaVk,
} from 'react-icons/fa';
import {
  LocationOn,
  Phone,
  AccessTime,
  ArrowForward,
} from '@mui/icons-material';
import MapSection from '../components/MapSection';

const Contacts = () => {
  return (
    <Box
      sx={{
        py: { xs: 5, md: 7 },
        background: `
          radial-gradient(circle at 10% 18%, rgba(201,161,74,0.15) 0%, transparent 30%),
          radial-gradient(circle at 90% 80%, rgba(20,36,95,0.10) 0%, transparent 30%),
          linear-gradient(135deg, #f5f3ed 0%, #e8e6df 100%)
        `,
        minHeight: '100vh',
      }}
    >
      <Container maxWidth="lg">
        {/* Заголовок */}
        <Typography
          variant="h2"
          textAlign="center"
          sx={{
            color: '#14245f',
            mb: 1,
            fontFamily: '"Playfair Display", serif',
            fontWeight: 700,
            fontSize: { xs: '2.2rem', md: '3.2rem' },
            letterSpacing: '-0.02em',
          }}
        >
          Контакты
        </Typography>

        <Typography
          textAlign="center"
          sx={{
            color: '#667085',
            mb: 4,
            maxWidth: 700,
            mx: 'auto',
            lineHeight: 1.8,
            fontSize: { xs: '1rem', md: '1.1rem' },
          }}
        >
          Мы работаем в двух студиях. Выберите удобный адрес и запишитесь онлайн.
        </Typography>

        <Grid container spacing={4}>
          {/* Левая колонка – контакты в стиле glassmorphism */}
          <Grid size={{ xs: 12, md: 5 }}>
            <Paper
              elevation={0}
              sx={{
                p: { xs: 3, md: 4 },
                borderRadius: 5,
                background: 'rgba(255,255,255,0.75)',
                backdropFilter: 'blur(12px)',
                border: '1px solid rgba(255,255,255,0.5)',
                boxShadow: '0 18px 40px rgba(0,0,0,0.06), 0 8px 20px rgba(20,36,95,0.04)',
                height: '100%',
                transition: 'all 0.3s ease',
                '&:hover': {
                  boxShadow: '0 24px 50px rgba(0,0,0,0.08), 0 10px 28px rgba(20,36,95,0.08)',
                },
              }}
            >
              <Typography
                sx={{
                  fontSize: 13,
                  fontWeight: 800,
                  letterSpacing: '0.12em',
                  textTransform: 'uppercase',
                  color: '#b2872f',
                  mb: 2,
                }}
              >
                Свяжитесь с нами
              </Typography>

              <Typography
                variant="h5"
                sx={{
                  fontFamily: '"Playfair Display", serif',
                  color: '#14245f',
                  mb: 3,
                  fontWeight: 700,
                }}
              >
                Lindos Beauty
              </Typography>

              {/* Адреса */}
              <Box sx={{ mb: 3 }}>
                <Typography
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1.5,
                    color: '#4b556f',
                    fontWeight: 500,
                    mb: 1.5,
                  }}
                >
                  <LocationOn sx={{ color: '#b2872f', fontSize: 20 }} />
                  <span>
                    <strong>ул. Революционная, 3</strong>
                    <Chip
                      label="основной"
                      size="small"
                      sx={{
                        ml: 1,
                        backgroundColor: '#14245f',
                        color: '#fff',
                        fontSize: 10,
                        height: 20,
                        fontWeight: 700,
                      }}
                    />
                  </span>
                </Typography>
                <Typography
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1.5,
                    color: '#4b556f',
                    fontWeight: 500,
                  }}
                >
                  <LocationOn sx={{ color: '#b2872f', fontSize: 20 }} />
                  <span>ул. Дачная, 27А</span>
                </Typography>
              </Box>

              <Divider sx={{ borderColor: 'rgba(20,36,95,0.08)', mb: 2 }} />

              {/* Телефон */}
              <Typography
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1.5,
                  color: '#14245f',
                  fontWeight: 700,
                  fontSize: '1.3rem',
                  mb: 1,
                }}
              >
                <Phone sx={{ color: '#b2872f', fontSize: 22 }} />
                +7 (917) 030-03-08
              </Typography>

              {/* Время работы */}
              <Typography
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1.5,
                  color: '#667085',
                  fontSize: '0.95rem',
                  mb: 3,
                }}
              >
                <AccessTime sx={{ color: '#b2872f', fontSize: 20 }} />
                Ежедневно с 10:00 до 21:00
              </Typography>

              {/* Соцсети – иконки в кружках */}
              <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
                <Button
                  component="a"
                  href="https://vk.com/lindos_beauty_samara"
                  target="_blank"
                  sx={{
                    minWidth: 48,
                    height: 48,
                    borderRadius: '50%',
                    backgroundColor: 'rgba(20,36,95,0.06)',
                    color: '#14245f',
                    '&:hover': {
                      backgroundColor: 'rgba(20,36,95,0.14)',
                    },
                  }}
                >
                  <FaVk size={22} />
                </Button>
                <Button
                  component="a"
                  href="https://t.me/lindos_beauty"
                  target="_blank"
                  sx={{
                    minWidth: 48,
                    height: 48,
                    borderRadius: '50%',
                    backgroundColor: 'rgba(20,36,95,0.06)',
                    color: '#14245f',
                    '&:hover': {
                      backgroundColor: 'rgba(20,36,95,0.14)',
                    },
                  }}
                >
                  <FaTelegramPlane size={22} />
                </Button>
                <Button
                  component="a"
                  href="https://taplink.cc/stories_beauty_samara?fbclid=PAZXh&utm_source=tg"
                  target="_blank"
                  sx={{
                    minWidth: 48,
                    height: 48,
                    borderRadius: '50%',
                    backgroundColor: 'rgba(20,36,95,0.06)',
                    color: '#14245f',
                    '&:hover': {
                      backgroundColor: 'rgba(20,36,95,0.14)',
                    },
                  }}
                >
                  <FaInstagram size={22} />
                </Button>
              </Box>

              {/* Кнопка записи */}
              <Button
                variant="contained"
                size="large"
                fullWidth
                endIcon={<ArrowForward />}
                onClick={() =>
                  window.open(
                    'https://n893698.yclients.com/company/833095/personal/menu?o=',
                    '_blank'
                  )
                }
                sx={{
                  borderRadius: 999,
                  py: 1.6,
                  textTransform: 'none',
                  fontSize: 16,
                  fontWeight: 700,
                  background:
                    'linear-gradient(135deg, #14245f 0%, #1a237e 58%, #2b3ea7 100%)',
                  boxShadow: '0 14px 28px rgba(26,35,126,0.24)',
                  '&:hover': {
                    background:
                      'linear-gradient(135deg, #101d4d 0%, #162067 58%, #22358f 100%)',
                  },
                }}
              >
                Записаться онлайн (YCLIENTS)
              </Button>
            </Paper>
          </Grid>

          {/* Правая колонка – карта */}
          <Grid size={{ xs: 12, md: 7 }}>
            <MapSection />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Contacts;